import React from 'react';
import {GeoJSON, LayerGroup, Popup, Tooltip} from "react-leaflet";
import {useDispatch, useSelector} from "react-redux";
import {updateBounds} from "../../../../../data/booking/actions/map";

function KmlLayer({kmlData, children, color = '#3388ff', zoomOn = true}) {
    const dispatch = useDispatch()
    const startStep = useSelector(state => state.booking.map.trip.startStep)
    const shouldZoomOn = startStep && startStep.step == null && zoomOn

    const {LineString, Point} = kmlData;

    return <LayerGroup>
        {LineString && <>
                <GeoJSON
                    data={{features: LineString}}
                    pathOptions={{
                        weight: 4,
                        color
                    }}
                    eventHandlers={{
                        add: (e) => {
                            e.target.bringToBack()
                            if (shouldZoomOn) {
                                const {_northEast, _southWest} = e.target.getBounds()
                                dispatch(updateBounds(_northEast, _southWest));
                            }
                        },
                        mouseover: (e) => {
                            if (e.target.getTooltip()) {
                                e.target.getTooltip().setLatLng(e.latlng)
                            }
                        },
                    }}

                >{children}</GeoJSON>
                <GeoJSON
                data={{features: LineString}}
                pathOptions={{
                    weight: 6,
                    color: 'white',
                }}
                eventHandlers={{
                    add: (e) => {
                        e.target.bringToBack()
                    },
                    mouseover: (e) => {
                        if (e.target.getTooltip()) {
                            e.target.getTooltip().setLatLng(e.latlng)
                        }
                    },
                }}

            >{children}</GeoJSON>
        </>}
    </LayerGroup>
}
export default KmlLayer;